module.exports = __webpack_public_path__ + "img/vrPanorams-solution-warp3-img6.a299f2f3.png";